import { datadogLogs } from '@datadog/browser-logs';

type BaseConfig = Parameters<(typeof datadogLogs)['init']>[0];
type RequiredConfigKeys = 'service' | 'env';
type OptionalConfig = Partial<Exclude<BaseConfig, RequiredConfigKeys>>;
type RequiredConfig = Required<Pick<OptionalConfig, RequiredConfigKeys>>;
type Config = OptionalConfig & RequiredConfig;

export const initDatadogLogs = (config: Config): void => {
	if (config.env === 'local') {
		return;
	}
	datadogLogs.init({
		clientToken: 'pub674cdda2ac0904efc0a20c07c43a29f5',
		site: 'datadoghq.com',
		sessionSampleRate: 100,
		silentMultipleInit: true,
		forwardConsoleLogs: [],
		forwardErrorsToLogs: false,
		...config,
	});
};
